'use client'

import { locales } from '@/i18n/settings'
import { DownOutlined } from '@ant-design/icons'
import { Button, Dropdown } from 'antd'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface LangSelectorProps {
  lang: string
}

export default function LangSelector({ lang }: LangSelectorProps) {
  // Get the current pathname  (fallback to '/')
  const pathname = usePathname() || '/'

  // Build href by swapping current lang prefix with target locale, or
  // prefixing the pathname when no language prefix exists.
  const buildLocaleHref = (toLocale: string) => {
    if (!pathname || pathname === '/') return `/${toLocale}`

    // If pathname starts with a language segment like '/en' or '/en/...',
    // replace that segment with the target locale.
    const fromLocale = lang || ''
    const prefix = `/${fromLocale}`

    if (
      fromLocale &&
      (pathname === prefix || pathname.startsWith(prefix + '/'))
    ) {
      // keep the rest of the path after the locale
      const rest = pathname.slice(prefix.length)
      return `/${toLocale}${rest}`
    }

    // Otherwise just prefix the pathname with the target locale
    return `/${toLocale}${pathname}`
  }

  const items = locales
    .filter((locale) => locale.id !== lang)
    .map((locale) => ({
      key: locale.id,
      label: <Link href={buildLocaleHref(locale.id)}>{locale.label}</Link>,
    }))

  return (
    <Dropdown menu={{ items, selectable: true }} trigger={['click']}>
      <Button icon={<DownOutlined />}>
        {locales.find((locale) => locale.id === lang)?.label}
      </Button>
    </Dropdown>
  )
}
